module.exports = __webpack_public_path__ + "static/img/4.bdc9025f.jpg";